import { MainHeader, Section, SectionParagraph } from '@/components/shared/Content';
import JoinCTA from '@/components/shared/JoinCTA';
import { useShowHeaderCtaOnScroll } from '@/hooks/useShowHeaderCtaOnScroll';
import desktopImg from '@/static/partners/desktop-main.png';
import mobileImg from '@/static/partners/mobile-main.png';
import { Box, Flex, font } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import type React from 'react';
import styled from 'styled-components';

interface HeroProps {
  title: string;
  subtitle: string;
  cta: string;
  url: string;
}

interface TopFoldSectionProps {
  bgImage: string;
  bgImageMobile: string;
}

const TopFoldSection = styled(Section)<TopFoldSectionProps>`
  position: relative;
  height: 620px;
  background: url(${(props: TopFoldSectionProps) => props.bgImage}) bottom no-repeat;
  background-size: contain;

  ${MEDIA_QUERIES.tabletAndDesktop`
      width: 90%;
      height: 541px;
      background-position-x: 50%;
  `}

  ${MEDIA_QUERIES.mobile`
    background: transparent;
    height: auto;
  `}
`;

const TopFoldHeader = styled(MainHeader)`
  ${MEDIA_QUERIES.desktop`  
    white-space: pre;
  `}

  line-height: 1.3;
`;

const TopFoldSubtitle = styled(SectionParagraph)`
  ${font('main', { fontSize: '1.8rem', lineHeight: '2.8rem' })};

  ${MEDIA_QUERIES.tabletAndDesktop`
      white-space: pre;
      ${font('main', { fontSize: '2.0rem' })};
  `}
  text-wrap: balance;
`;

const CTA = styled(JoinCTA)`
  ${MEDIA_QUERIES.mobile`
      box-shadow: none;
  `}
`;

export const Hero: React.FC<HeroProps> = ({ title, subtitle, cta, url }) => {
  const { ref } = useShowHeaderCtaOnScroll();
  return (
    <Flex width={1} justifyContent="center">
      <TopFoldSection bgImage={desktopImg.src} bgImageMobile={mobileImg.src}>
        <TopFoldHeader>{title}</TopFoldHeader>
        <Box mt={[40, 34]} mb={[50, 61]} width={[7 / 10]}>
          <TopFoldSubtitle>{subtitle}</TopFoldSubtitle>
        </Box>
        <CTA
          ref={ref}
          size="big"
          flavor="primary"
          glowing
          customUrl={url}
          data-event="partners_page.CTA.click"
          minWidth={200}
        >
          {cta}
        </CTA>
      </TopFoldSection>
    </Flex>
  );
};
